var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.realData)?[_c('i-k-p-r-node',{staticStyle:{"font-family":"monospace"},attrs:{"node":_vm.parseNode(_vm.realData),"level":""}})]:[_c('div',[_vm._v(" "+_vm._s(_vm.$t('cantPreviewDataNow'))+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }